import React from 'react';
import PropTypes from 'prop-types';
import './tag.css';

const Tag = props => {
  return <span className="tag">{props.title}</span>;
};

Tag.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Tag;



// WEBPACK FOOTER //
// ./src/ui/src/component/tag/tag.js